import React, { useEffect, useState } from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import ElectronicExaminationList from '../../../Nczi/Components/ElectronicExamination/List/ElectronicExaminationList';
import NCZIPatient from '../../../Nczi/Components/NCZIPatient/NCZIPatient';
import ElectronicExaminationVLList from '../../../Nczi/Components/ElectronicExamination/List/ElectronicExaminationVLList';
import EnumsList from '../../../Nczi/Components/VerifyEnums/List/EnumsList';

interface Props {
	patientId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicExamination: React.FC<Props> = ({
	patientId,
	setIsLoading,
}) => {
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);

	useEffect(() => {
		handleLoadSteps();
	}, []);

	const handleLoadSteps = () => {
		const tempSteps: NavigationStepperItemType[] = [
			{
				name: 'patientTreatment.electronicExamination.list.title',
				key: 'list',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIPatient>
						<ElectronicExaminationList setIsLoading={setIsLoading} />
					</NCZIPatient>
				),
			},
			{
				name: 'patientTreatment.electronicExamination.vl.title',
				key: 'vl',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIPatient>
						<ElectronicExaminationVLList setIsLoading={setIsLoading} />
					</NCZIPatient>
				),
			},
			{
				name: 'patientTreatment.electronicExamination.verifyEnums.title',
				key: 'verifyEnums',
				component: (params: NavigationStepperComponentParams) => (
					<EnumsList setIsLoading={setIsLoading} />
				),
			},
		];

		setSteps(tempSteps);
	};

	if (!steps.length) {
		return <></>;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='list'
				canSkip={true}
			/>
		</>
	);
};

export default ElectronicExamination;
